export default {
    add_stage: "Этап кошуу",
    additional: "Кошумча",
    alternative: "Альтернативдүү",
    amount_completed: "Аткарылган сумма",
    apply_plan_treatment: "Дарылоо планын колдонуу",
    apply_to_which_teeth: "Кайсы тиштерге кайрылуу керек",
    apply_treatment_stage_template: "Дарылоо кадамынын үлгүсүн колдонуңуз",
    are_you_sure_you_want_to_cancel_plan: "Сиз чындыгында дарылоо планыңызды жокко чыгаргыңыз келеби?",
    by_stages: "Этаптар боюнча",
    calls_planning: "Чалууларды пландаштыруу",
    cancel_plan_treatment: "Дарылоо планын жокко чыгаруу",
    changes_in_current_stage_were_not_saved: "Учурдагы кадамдагы өзгөртүүлөр сакталбайт",
    choose_criterias_for_fill: "Толтуруу үчүн керектүү критерийлерди тандаңыз",
    collapse: "Жыйыштыруу",
    comments: "Комментарийлер",
    completed_sum: "Аткарылган сумма",
    complex_doctor: "Комплекстин дарыгерлери",
    'DD.MM.YYYY': "DD.MM.YYYY",
    deadline2: "Мөөнөтү",
    delete_stage: "Этапты жок кылуу",
    document_header: "Дарылоо планында шапка",
    editing_is_blocked_now_user_is_working: "Түзөтүү убактылуу жеткиликсиз: {user} учурда иштеп жатат",
    expand: "Кеңейтүү",
    grouped: "Топтоштурулган",
    grouped_by_services: "Кызматтар боюнча топтоштурулган",
    grouped_by_teeth: "Тиштер боюнча топтоштурулган",
    hide_tooth_formula: "Тиш формуласын жашыруу",
    kits_and_materials: "Комплекттер жана материалдар",
    last_update: "Акыркы өзгөрүш",
    left: "Солго",
    level_description: "Этаптын сүрөттөлүшү",
    main_complaints: "Негизги даттануулар",
    not_signed: "Коло коюлган эмес",
    notification_date: "Билдирүү датасы",
    plan: "План",
    plan_status: "Пландын абалы",
    plan_treatment_application: "Дарылоо планын колдонуу",
    plan_treatment_status: "Дарылоо планынын статусу",
    plan_type: "Пландын түрү",
    planned_sum: "Пландаштырылган сумма",
    previous_visits: "Өткөн сапарлар",
    quantity: "Саны",
    recommended: "Сунушталган",
    reset_all: "Бардыгын өзгөртүү",
    route_list: "Маршруттук баракча",
    save_as_plan_stage_template: "Дарылоо кадамы үлгүсү катары сактоо",
    select_a_doctor_2: "Дарыгер тандаңыз",
    select_all: "Баарын белгилөө",
    select_field: "Багыт тандаңыз",
    select_number: "Номерди тандаңыз",
    select_plan: "План тандаңыз",
    select_type: "Түрү тандоо",
    services_selected: "Кызматтар тандалды",
    show_tooth_formula: "Стоматологиялык формуланы көрсөт",
    sign_without_upload: "Жүктөөсүз коюу",
    signed_at: "Кол коюлган",
    stage_deletion_confirm_text: "Этап калыбына келтирүү мүмкүнчүлүгү жок өчүрүлөт. Бардык сакталбаган өзгөртүүлөр жоголот.",
    stage_doctor: "Этап дарыгери",
    stage_title: "Сахна аты",
    stages_discount: "Этап менен арзандатуу",
    total_sum: "Бардык сумма",
    treatment_plan_amount: "Дарылоо планынын суммасы",
    treatment_plan_doctor: "Дарылоо планынын дарыгери",
    treatment_template_application: "Дарылоо үлгүсүн колдонуу",
    which_fields_to_fill: "Кайсы талааларды толтуруу керек",
    write_patient_complaints: "Бейтаптын арыздарын жазыңыз",
    write_stage_description: "Этаптын сүрөттөмөсүн жаз"
}
